var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 12.2761 7.22386 12.5 7.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5H7.5C7.22386 11.5 7 11.7239 7 12ZM7 16C7 16.2761 7.22386 16.5 7.5 16.5H20.5C20.7761 16.5 21 16.2761 21 16C21 15.7239 20.7761 15.5 20.5 15.5H7.5C7.22386 15.5 7 15.7239 7 16ZM7.5 7.5C7.22386 7.5 7 7.72386 7 8C7 8.27614 7.22386 8.5 7.5 8.5H20.5C20.7761 8.5 21 8.27614 21 8C21 7.72386 20.7761 7.5 20.5 7.5H7.5ZM7 12C7 12.2761 7.22386 12.5 7.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5H7.5C7.22386 11.5 7 11.7239 7 12ZM7 16C7 16.2761 7.22386 16.5 7.5 16.5H20.5C20.7761 16.5 21 16.2761 21 16C21 15.7239 20.7761 15.5 20.5 15.5H7.5C7.22386 15.5 7 15.7239 7 16ZM7.5 7.5C7.22386 7.5 7 7.72386 7 8C7 8.27614 7.22386 8.5 7.5 8.5H20.5C20.7761 8.5 21 8.27614 21 8C21 7.72386 20.7761 7.5 20.5 7.5H7.5Z",
    fill: "#717C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15.0814H4V14.4419H6V17H4V16.3605H5.33333V16.0407H4.66667V15.4012H5.33333V15.0814Z",
    fill: "#717C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.55814H4.66667V7.63953H4V7H5.33333V9.55814Z",
    fill: "#717C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 11.1279H4V10.4884H6V11.064L4.8 12.407H6V13.0465H4V12.4709L5.2 11.1279Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/ordered-list.d0bfd96e7967d9895841af4f406bca2a.svg";
export { ForwardRef as ReactComponent };